import React from 'react';

export default function Space({ height, width }) {
  return <div style={{ height: height || 0, width: width || 0 }} />;
}
